import { render, staticRenderFns } from "./JobsStatusList.vue?vue&type=template&id=32e6f79b&"
import script from "./JobsStatusList.vue?vue&type=script&lang=js&"
export * from "./JobsStatusList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports